import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceover: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceover"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10 9.5H8V14.5H10L11.5 16.5H13V7.5H11.5L10 9.5ZM14.0498 10.0996C15.3165 11.0496 15.3165 12.9504 14.0498 13.9004L14.9502 15.0996C17.0164 13.5496 17.0164 10.4504 14.9502 8.90039L14.0498 10.0996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceover;
